import styled from "@emotion/styled";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH } from "/constants/vp-sizes";
import { BRAND_BLACK_BACKGROUND_COLOR, WHITE_COLOR_NAME } from "styles/color-consts";
import Colors from "styles/colors";
export const StyledWhatsNewFirstFoldComponent = styled.div`
  padding-top: 60px;
  display: flex;
  flex-direction: row;

  .left-space {
    min-width: calc((100vw - ${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px) / 2);
    flex-grow: 1;
  }

  position: relative;

  .left-section {
    width: 40%;
    display: flex;
    flex-direction: column;

    .buttons-wrapper {
      display: flex;
      flex-direction: row;
      padding-left: 32px;
      gap: 20px;

      .circle-with-arrow {
        display: flex;
        width: 35px;
        height: 35px;
        border-radius: 50%;
        background-color: ${Colors[WHITE_COLOR_NAME]};
        position: relative;
        border: 1px solid ${Colors[BRAND_BLACK_BACKGROUND_COLOR]};
        justify-content: center;
        align-items: center;
        font-size: 1.75rem;
        padding-top: 3px;
        cursor: default;

        :not(.first-slide):not(.last-slide):hover {
          color: ${Colors[WHITE_COLOR_NAME]};
          background-color: ${Colors[BRAND_BLACK_BACKGROUND_COLOR]};
          cursor: pointer;
        }
      }
    }

    .full-paragraph-component {
      margin: 100px 0 20px 0;
    }
  }

  .carousel-wrapper {
    width: 60%;
  }

  .card {
    opacity: 0;
    transition: opacity 0.5s ease-in-out;
  }

  .slick-slide.slick-active .card {
    opacity: 1;
  }
`;
